module.exports = __webpack_public_path__ + "static/media/app_screen.5c702f58.png";